import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'bizz-conditional-bg-tag',
  standalone: true,
  imports: [NgClass],
  templateUrl: './conditional-bg-tag.component.html',
  styleUrls: ['./conditional-bg-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConditionalBgTagComponent {

  public value = input.required<string>();

  public backgroundColor = input<string>('');
  public foregroundColor = input<string>('');

  public columnHasDisplayStyle = input<boolean>(false);
  public disableTruncate = input<boolean>(false);

  public hasCustomColors = computed(() => !!this.backgroundColor() || !!this.foregroundColor());

}
